import carrierZoneModule from "../carrierZoneModule"

carrierZoneModule.controller("carrierZoneMaxValueController", ["$scope", "sourceEntity", "entity", "carrierZoneBaseController", ($scope, sourceEntity, entity, carrierZoneBaseController)=> {
    carrierZoneBaseController("carrier-zone-max-value", $scope, sourceEntity, entity)
}])